import { __awaiter, __generator, __read } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchIdentity } from '@office-start/identity-service';
import { authOneDsSinkPromise } from '@office-start/otel-telemetry-service';
import { logFeature } from '@office-start/telemetry-service';
import { fetchUserEntitlements } from '@office-start/user-entitlements-service';
import create from 'zustand';
export var useFoldersStore = create(function (set, get) { return ({
    foldersData: undefined,
    initializePromise: undefined,
    initialize: function (force) {
        var initializePromise = get().initializePromise;
        if (!initializePromise || force) {
            initializePromise = new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                var mfsFolders, _a, componentContext, identity, userEntitlements, otelSinkCallback, mod, foldersModule, clientBuilder, _b, clientBuilderInstance, foldersClient, folders;
                var _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            mfsFolders = get().foldersData;
                            if (mfsFolders && !force) {
                                return [2 /*return*/, resolve('Existing Folders client being consumed')];
                            }
                            return [4 /*yield*/, Promise.all([
                                    fetchOfficeComponentContext(),
                                    fetchIdentity(),
                                ])];
                        case 1:
                            _a = __read.apply(void 0, [_d.sent(), 2]), componentContext = _a[0], identity = _a[1];
                            return [4 /*yield*/, fetchUserEntitlements()];
                        case 2:
                            userEntitlements = (_d.sent()).result;
                            if (!userEntitlements) {
                                return [2 /*return*/, reject('UserEntitlements not set.')];
                            }
                            if (!componentContext) {
                                return [2 /*return*/, reject('OfficeComponentContext not set.')];
                            }
                            if (userEntitlements.hasOwnProperty('OneDriveResourceId') &&
                                !userEntitlements.OneDriveResourceId &&
                                !componentContext.inMockMode) {
                                return [2 /*return*/, reject('No valid ODSP URL present.')];
                            }
                            if (!identity) {
                                return [2 /*return*/, reject('OfficeIdentity not set.')];
                            }
                            otelSinkCallback = function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, Promise.race([
                                            authOneDsSinkPromise,
                                            new Promise(function (resolve, reject) {
                                                if (componentContext.inMockMode) {
                                                    resolve();
                                                    return;
                                                }
                                                setTimeout(function () { return reject(); }, 5000);
                                            }),
                                        ])];
                                });
                            }); };
                            return [4 /*yield*/, import('../operations/lazyGetFolders')];
                        case 3:
                            mod = _d.sent();
                            if (!mod) {
                                reject('Unable to load Folders module.');
                            }
                            foldersModule = mod;
                            if (!componentContext.inMockMode) return [3 /*break*/, 5];
                            return [4 /*yield*/, import('../operations/lazyGetFoldersLocalClientBuilder')];
                        case 4:
                            _b = (_d.sent()).FoldersLocalClientBuilder;
                            return [3 /*break*/, 6];
                        case 5:
                            _b = foldersModule.FoldersProdClientBuilder;
                            _d.label = 6;
                        case 6:
                            clientBuilder = _b;
                            clientBuilderInstance = new clientBuilder({
                                // appId is used by MFS core for access control, so items created by 1 app can't be deleted by another app
                                // appName will eventually be deprecated
                                appId: 'office-hub',
                                appName: 'officehub',
                                podLocation: 'Personal',
                                mfsAccessTokenCallback: function () {
                                    return componentContext
                                        .getAccessToken('MfsService')
                                        .then(function (resp) { return resp.token; });
                                },
                                odspAccessTokenCallback: function () {
                                    return componentContext
                                        .getAccessToken('OneDrive', false, userEntitlements.OneDriveResourceId)
                                        .then(function (resp) { return resp.token; });
                                },
                                pushChannelTokenCallback: function () {
                                    return componentContext
                                        .getAccessToken('FluidPushChannel')
                                        .then(function (resp) { return resp.token; });
                                },
                                sessionId: componentContext.sessionId,
                                waitForUpdates: false,
                                sinkCallback: otelSinkCallback,
                                completedCallback: function () { return undefined; },
                                oneDriveDomain: (_c = userEntitlements.OneDriveResourceId) === null || _c === void 0 ? void 0 : _c.replace('https://', ''),
                                userCacheKey: identity.puid,
                            });
                            return [4 /*yield*/, clientBuilderInstance.build()];
                        case 7:
                            foldersClient = _d.sent();
                            if (!foldersClient) {
                                reject('Unable to build Folders Client.');
                            }
                            folders = {
                                foldersClient: foldersClient,
                                foldersModule: foldersModule,
                            };
                            set({ foldersData: folders });
                            return [2 /*return*/, resolve('Folders client created')];
                    }
                });
            }); });
            initializePromise
                .then(function (info) {
                logFeature({
                    featureName: "Other" /* KnownFeatureNames.Other */,
                    eventName: 'MfsFoldersInitialization',
                    params: {
                        Success: true,
                        info: info,
                    },
                });
            })
                .catch(function (errorInfo) {
                logFeature({
                    featureName: "Other" /* KnownFeatureNames.Other */,
                    eventName: 'MfsFoldersInitialization',
                    params: {
                        Success: false,
                        DebugInfo: errorInfo,
                    },
                });
            });
            set({ initializePromise: initializePromise });
        }
        return initializePromise;
    },
}); });
//# sourceMappingURL=store.js.map